<template>
    <div>
        <!-- <section class="hero" style="position: relative">
            <v-container class="menu-slogan">
                <v-row align="center" justify="stretch">
                <v-col class="white--text" cols="12" lg="6" md="6">
                    <h1 class="orange--text display-2">LA FROMENTINE</h1>
                    <p>{{$t("menu.subtitle")}}</p>
                    <v-btn x-large class="orange white--text" text> {{$t("menu.orderNow")}}</v-btn>
                </v-col>
                </v-row>
            </v-container>
            <v-img src="../../assets/logo.jpg" max-width="130" style="position: absolute; bottom: 0"></v-img>
        </section> -->
        <div class="cart">
            <v-data-table :headers="headers" :items="cart" class="elevation-3">
                <template v-slot:item.name="{ item }">
                    <div class="p-2">
                        <p style="width: 360px">
                            {{ item.product.name }}
                            <template v-if="item.extra != null">
                                (<small>avec choix d’accompagnement:  <strong>{{ item.extra.map(a => a.name).join() }}</strong> </small>)
                            </template>
                        </p>
                        
                    </div>
                </template>

                <template v-slot:item.image="{ item }">
                    <div class="p-2" v-if="item.product.img_url != ''">
                        <img :src="item.product.img_url" width="230px" height="140px"/>
                    </div>
                </template>

                <template v-slot:item.price="{ item }">
                    <div class="p-2">
                        $ {{ item.price.toFixed(2) }}
                    </div>
                </template>

                <template v-slot:item.quantity="{ item }">
                    <div class="p-2">
                        <v-btn x-small @click="decrementProductCart(item)"><v-icon>mdi-minus</v-icon></v-btn>
                          <span style="margin-left: 5px; margin-right: 5px;">{{ item.quantity }}</span>
                        <v-btn x-small @click="incrementProductCart(item)"><v-icon>mdi-plus</v-icon></v-btn>
                    </div>
                </template>
                <template v-slot:item.total="{ item }">
                    <div class="p-2">
                        <span style="margin-left: 5px; margin-right: 5px;">$ {{ item.total.toFixed(2) }}</span>
                    </div>
                </template>
                <template v-slot:item.remove="{ item }">
                    <div class="p-2">
                        <v-btn x-small color="error" @click="removeFromCart(item)"><v-icon>mdi-delete</v-icon></v-btn>
                    </div>
                </template>
            </v-data-table>
            <!-- <div id="head">
                <v-data-table :headers="headers" :items="carts" class="elevation-0">
          <template v-slot:item.image="{ item }">
            <div class="p-2">
              <v-img :src="item.image" :alt="item.name" height="100px"></v-img>
            </div>
          </template>
        </v-data-table>
                <h3>Shopping Cart</h3>
                <div id="price">Price</div>
                <div id="quantity">Quantity</div>
                <div id="total">Total</div>
            </div>
            <div v-for="buyitem in cart" v-bind:key="buyitem.id">
                <CartIem  :item="buyitem"></CartIem>
            </div> -->
            <div class="cart-actions">
                <h5 >{{ $t('cart.sub_total') }}: $ {{ cartTotal.toFixed(2) }}</h5>

                <v-btn color="primary" @click="checkOut">{{ $t('cart.continue_pay') }}</v-btn>
            </div>
            
        </div>
    </div>
</template>

<script>
import CartIem from "./partials/CartIem"
import { mapGetters , mapMutations} from "vuex";

export default {
    name: 'Navbar',
    data() {
        return {
            headers: [
                { text: "Image", value: "image", sortable: false },
                { text: "Name", value: "name", sortable: false },
                { text: "Price", value: "price", sortable: false },
                { text: "Quantity", value: "quantity", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Actions", value: "remove", sortable: false },
            ]
        };
    },
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components:{
        CartIem
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters('products', {
            cart: 'getCart',
            cartTotal: 'cartTotal',
        }),
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        ...mapMutations({
            incrementProductCart: "products/incrementProductCart",
            decrementProductCart: "products/decrementProductCart",
            removeFromCart: "products/removeFromCart",
        }),
        async checkOut () {
            if(window.localStorage.getItem('token') === null || window.localStorage.getItem('token') === '') {
                window.localStorage.removeItem('previous');
                await window.localStorage.setItem("previous", '/payment')
                this.$router.push('/auth/login');
            } else {
                this.$router.push('/payment');
            }
        },
        calculateTotal (v) {
            let t = v.price * v.quantity;
            return t.toFixed(2);
        }
    },
}
</script>


<style lang="scss" scoped>
.hero {
  height: 45vh;
  background: linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('../../assets/img/frometine-image-main.jpg') no-repeat center center;
  background-size: cover;
}
.menu-slogan {
  padding-top: 30px;
}
.cart {
    padding-top: 10px;
    padding-left: 3%;
    padding-right: 3%;
    padding-bottom: 10%;
    margin-top: 10px;
    overflow: hidden;
    #head {
      width: 100%;
      border-bottom: 1px solid #BFBFBF;
      height: 40px;
      display: block;
      h3 {
        display: inline-block;
        line-height: 40px;
        margin: 0;
      }
      #price {
        display: inline-block;
        color: #777777;
        margin-left: 200px;
        line-height: 40px;
      }
      #quantity {
        display: inline-block;
        color: #777777;
        margin-left: 100px;
        line-height: 40px;
      }
      #total {
        display: inline-block;
        color: #777777;
        line-height: 40px;
        float: right;
      }
    }
    h5 {
      font-size: 1.2rem;
      text-align : right;
      color: rgb(6, 6, 77);
      margin-bottom: 10px;
    }

    .cart-actions {
      font-size: 1.2rem;
      text-align : right;
    }
}

</style>

